import { APP_PERMISSIONS, hasPermission as checkPermission } from '@/lib/auth/permissions';
import type { AppPermission } from '@/lib/auth/permissions';
import { usePermissionsQuery } from '@/hooks/usePermissionsQuery';

export function usePermissions() {
  const query = usePermissionsQuery();

  const permissions = query.data?.permissions ?? [];
  const role = query.data?.role ?? '';
  const isSuperAdmin = permissions.includes(APP_PERMISSIONS.SUPERADMIN);

  return {
    permissions,
    role,
    hasPermission: (p: AppPermission) => checkPermission(permissions, p),
    isSuperAdmin,
    hasAdminAccess:
      isSuperAdmin ||
      checkPermission(permissions, APP_PERMISSIONS.MANAGE_USERS) ||
      checkPermission(permissions, APP_PERMISSIONS.ENTITY_ADMIN),
    isLoading: query.isLoading,
  };
}
